import React from 'react';
import Select from './Select';
import { FormChangeEvent, useSharedContext } from '../../pages/GTBCustomize/ContextProviders/SharedContext';
import styles from './shippingLocationForm.module.scss';
import { determineZipCodeLabel } from './helpers';
import ZipCodeInput from './ZipCodeInput';
import { trackFormInput } from '../../utils/segment/events';
import { SHIPPING_INFO_INPUT_FIELD } from '../../utils/segment/constants';

const ShippingLocationForm = () => {
  const {
    countries,
    handleFormStateOnChange,
    prospect: { address },
  } = useSharedContext();

  const handleSelectChange = (e: FormChangeEvent | React.FormEvent) => {
    handleFormStateOnChange(e);
    trackFormInput(SHIPPING_INFO_INPUT_FIELD);
  };

  return (
    <div className={styles.shippingLocation} data-testid="shipping-details-section">
      <div className={styles.shippingLocationTitleWrapper}>
        <h4 className={styles.shippingLocationTitle}>
          Shipping Location&nbsp;
          <span className={styles.shippingLocationSubtitle}>
            Fill out the full shipping address on the next page
          </span>
        </h4>
      </div>
      <div className={styles.shippingLocationInputs}>
        <Select
          countries={countries}
          name="shipCountry"
          value={address.shipCountry}
          label="Country"
          handleOnChange={handleSelectChange}
          currentCountryCode={address.shipCountry}
          withPadding
          errorMessage="Please select a country."
        />
        <Select
          countries={countries}
          name="shipState"
          value={address.shipState}
          label="State"
          handleOnChange={handleSelectChange}
          currentCountryCode={address.shipCountry}
          withPadding
          errorMessage="Please select a state."
        />
        <ZipCodeInput
          label={determineZipCodeLabel(countries, address.shipCountry)}
          placeholder="Zip Code"
          maxLength={10}
          value={address.shipZipCode}
          handleInput={handleSelectChange}
          name="shipZipCode"
          type="text"
          errorMessage="Please enter a valid zip code."
        />
      </div>
    </div>
  );
};

export default ShippingLocationForm;
